<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <h3 class="modal-title">파일 업로드 중</h3>
      <p class="modal-description">
        회의 자료를 준비하고 있습니다. 잠시만 기다려주세요...
      </p>
      <div class="progress-container">
        <div class="progress-bar" :style="{ width: progress + '%' }"></div>
      </div>
      <span class="progress-text">{{ Math.floor(progress) }}%</span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  progress: {
    type: Number,
    required: true,
    default: 0,
  },
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001; /* 다른 모달 위에 표시되도록 z-index 조정 */
}

.modal-content {
  background: white;
  padding: 2.5rem;
  border-radius: 0.75rem;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.75rem;
}

.modal-description {
  color: #6b7280;
  margin-bottom: 2rem;
}

.progress-container {
  width: 100%;
  height: 12px;
  background-color: #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-bar {
  height: 100%;
  background-color: #e60012;
  border-radius: 6px;
  transition: width 0.4s ease-in-out;
}

.progress-text {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
}
</style> 